export default "__VITE_ASSET__C$YOxfqd__"